<template>
  <div class="text-center">
    <a href="#"
      color="primary"
      @click="openDialog"
    >
      Give Feedback
    </a>
    <b-modal
      v-model="dialog"
      width="600px"
      title="User Feedback"
      @ok="handleOk"
      @show="resetData"
      @hidden="closeDialog"
    >
      <form ref="form" @submit.stop.prevent="saveFeedback">
        <b-form-row class="pb-3">
          <b-col cols="12" sm="12"
            ><b-form-input
              :state="titleValidation"
              v-model="formData.title"
              placeholder="Title"
              required
            ></b-form-input>
            <b-form-invalid-feedback :state="titleValidation">
              Title is required.
            </b-form-invalid-feedback>
          </b-col>
        </b-form-row>
        <b-form-row class="pb-3">
          <b-col cols="12" sm="12"
            ><b-form-select
              placeholder="Feedback Type"
              :state="witValidation"
              v-model="formData.workItemType"
              :options="workItemTypes"
              required
            ></b-form-select>
            <b-form-invalid-feedback :state="witValidation">
              Selection is required.
            </b-form-invalid-feedback>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col cols="12" sm="12"
            ><b-form-textarea
              v-model="formData.message"
              :state="messageValidation"
              placeholder="Message"
              rows="5"
              auto-grow
              row-height="30"
              required
            ></b-form-textarea>
            <b-form-invalid-feedback :state="messageValidation">
              Message is required.
            </b-form-invalid-feedback>
          </b-col>
        </b-form-row>
      </form>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      saveClicked: false,
      formData: {
        title: null,
        message: null,
        workItemType: null,
        project: "CARS",
      },
      workItemTypes: [
        { text: "Issue", value: "Bug" },
        { text: "Request", value: "Task" },
      ],
    };
  },
  computed: {
    titleValidation() {
      return this.formData.title !== null && this.formData.title.length > 0;
    },
    witValidation() {
      return this.formData.workItemType !== null;
    },
    messageValidation() {
      return this.formData.message !== null && this.formData.message.length > 0;
    },
  },
  props: {
    userPrincipalName: String
  },
  methods: {
    checkFormValidity() {
      let isValid = this.$refs.form.checkValidity();
      return isValid;
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.saveFeedback();
    },
    async saveFeedback() {
      if (!this.checkFormValidity()) {
        return;
      }

      const url = 'https://api.genesis.cobb.app/userfeedback';

      try {
        await this.$axios.post(url, this.formData, {
          params: { userId: this.userPrincipalName }
        });
        this.$emit("showSuccessful", "Feedback submitted");
      } catch (ex) {
        console.error(ex);
        this.$emit("showFailure", "Unable to submit feedback");
        this.saveClicked = false;
        return;
      }

      this.closeDialog();
    },
    openDialog() {
      this.dialog = true;
      this.$emit("feedbackClicked", true);
    },
    resetData() {
      this.formData.title = null;
      this.formData.workItemType = null;
      this.formData.message = null;
      this.saveClicked = false;
    },
    closeDialog() {
      this.resetData();
      this.$emit("feedbackClicked", false);
      this.dialog = false;
    },
  },
};
</script>

<style scoped>

</style>
